'use strict';

app.service('Leaderboard', function ($q, $http) {
  var BASE_URL = '/api/v1/instances';
  this.fetch = function (instanceId, params) {
    return $http.get(BASE_URL + '/' + instanceId + '/leaderboard', {params: params})
      .then(_.property('data'));
  };

  this.userRank = function (instanceId, userId) {
    return $http.get(BASE_URL + '/' + instanceId + '/leaderboard/' + userId)
      .then(_.property('data'));
  };
});
